import { AppointmentTooltip } from '@devexpress/dx-react-scheduler-material-ui';
import { Grid } from '@mui/material';
import { Lens } from '@mui/icons-material';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useNavigate } from 'react-router-dom';
import { formatDate, formatTime } from '../../../../../utils/dates';
import classes from './CustomAppointmentTooltip.module.css';
import CustomButton from '../../../../components/UI/CustomButton/CustomButton';

const TooltipContent = ({ appointmentData }: AppointmentTooltip.ContentProps) => {
  const navigate = useNavigate();

  const redirect = (id: string | number | undefined) => {
    if (id) navigate(`/consultas/${id}`);
    else navigate('/');
  };

  if (!appointmentData) return <div />;

  return (
    <div className={classes.content}>
      <Grid container alignItems='flex-start' className={classes.titleContainer}>
        <Grid item xs={2} className={classes.textCenter}>
          <Lens className={classes.lens} sx={{ color: appointmentData.color }} />
        </Grid>
        <Grid item xs={10}>
          <div>
            <div className={`${classes.title} ${classes.dateAndTitle}`}>
              {appointmentData.specialty.name} - {appointmentData.doctor.name}
            </div>
            <div className={`${classes.text} ${classes.dateAndTitle}`}>
              {formatDate(appointmentData.startDate as Date)}
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid container className={classes.container}>
        <Grid item xs={2} sx={{ textAlign: 'center' }}>
          <PersonIcon className={classes.icon} />
        </Grid>
        <Grid item xs={10}>
          <span>{appointmentData.patient.name}</span>
        </Grid>
      </Grid>
      <Grid container className={classes.container}>
        <Grid item xs={2} sx={{ textAlign: 'center' }}>
          <AccessTimeIcon className={classes.icon} />
        </Grid>
        <Grid item xs={10}>
          <span>{`${formatTime(appointmentData.startDate as Date)} - ${formatTime(
            appointmentData.endDate as Date
          )}`}</span>
        </Grid>
      </Grid>
      <Grid container className={classes.container} sx={{ justifyContent: 'center' }}>
        <CustomButton color={appointmentData.color} onClick={() => redirect(appointmentData.id)}>
          Tomar datos
        </CustomButton>
      </Grid>
    </div>
  );
};

const CustomAppointmentTooltip = () => {
  return <AppointmentTooltip contentComponent={TooltipContent} showCloseButton showDeleteButton />;
};

export default CustomAppointmentTooltip;
